import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScanProviderInfo } from '../common/ScanProviderInfo';
import { ApiServiceBase } from './ApiServiceBase';

@Injectable({
  providedIn: 'root',
})
export class ScanProviderService extends ApiServiceBase {
  protected readonly path = 'scanproviders';

  get(): Observable<ScanProviderInfo[]> {
    return this.http
      .get<ScanProviderInfo[]>(this.getUrl());
  }
}
